export default __webpack_public_path__ + "static/media/icn_motion_fitness.c234bcb8.svg";